import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-109">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-110">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-111" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] flex flex-col overflow-hidden" data-id="element-112">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-5 border-b border-gray-100 shrink-0" data-id="element-113">
              <h2 className="text-xl font-bold text-[#1A1A2E]" data-id="element-114">{title}</h2>
              <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100 transition-colors text-gray-500 hover:text-gray-800" aria-label="Cerrar" data-id="element-115">
                <X className="w-5 h-5" data-id="element-116" />
              </button>
            </div>

            {/* Content */}
            <div className="px-6 py-6 overflow-y-auto text-gray-600 text-sm leading-relaxed space-y-4" data-id="element-117">
              {children}
            </div>

            {/* Footer */}
            <div className="px-6 py-4 border-t border-gray-100 shrink-0" data-id="element-118">
              <button onClick={onClose} className="w-full py-2.5 bg-[#0D6E6E] hover:bg-[#0a5a5a] text-white font-semibold rounded-lg transition-colors text-sm" data-id="element-119">
                Entendido
              </button>
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}